var BaseRowView = require('../baseRowView/view');


module.exports = BaseRowView.extend({

    ROW_TYPE_CLASS_NAME: 'fr-hit-row-view-search',

    serializeData: function() {

        var baseCxt = BaseRowView.prototype.serializeData.call( this );

        return _.extend( baseCxt, {
            search: this.model.get('search').get('searchTerm'),
            isSearchRow: true
        });

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/searchRow/base.js
 ** module id = 632
 ** module chunks = 0
 **/